import React from "react";
import "./CSS/customInput.css";
import { useThemeColors } from "../Context/Theme";
 
function CustomInput({
  type,
  label,
  value,
  onChange,
  isValid,
  className,
  placeholder,
  onKeyDown,
  validationMessage,
  required,
  name,
  children,
  style,
  width,
  height,
  marginTop,
  marginBottom,
  maxWidth,
  borderRadius,
  minWidth,
  border,
  backgroundColor,
  onBlur,
  endIcon
}) {
  const {
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors()
  const inputId = `inputField-${name}`;
  return (
    <div
      data-mdb-input-init
      className="form-outline"
      style={{
        width: width || 0,
        backgroundColor: backgroundColor || "",
        height: "10vh",
      }}
    >
      <label
        className="form-label"
        style={{ fontSize: fontSizeHeading || "14px", fontWeight: fontWeightHeading || "600", fontFamily: fontFamilyHeading, color: "#393939" }}
        htmlFor={inputId} 
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      {type === "select" ? (
        <select
          id={inputId}
          className={`form-control form-control-lg ${className}`}
          value={value}
          onChange={onChange}
          name={name}
          style={{ padding: "0px 0px", fontSize: fontSize || "1em", fontFamily }}
        >
          {children}
        </select>
      ) : (
        <div 
        style={{
          
          borderRadius: "10px",
          
          
          height:"48px",
          position: "relative",
          
        }}
        >
        <input
          type={type}
          id={inputId} 
          className={`form-control form-control-lg ${className}`}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          onBlur={onBlur}
          style={{
            padding: endIcon? "0px 40px 0px 15px":"0px 15px",
            borderRadius: "10px",
            border: "1px solid #C6C6C6",
            paddingRight: "15%",
            fontSize: fontSize || "1em",
            ...style,
            fontFamily,
            fontWeight,
            "::placeholder": { fontSize: fontSize || "2em", fontWeight: fontWeight || "500", fontFamily },
          }}
        />
         {endIcon && (
            <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", backgroundColor:"white" }}>
              {endIcon}
            </span>
          )}
        </div>

      )}
      {validationMessage && (
        <div className="invalid-feedback" style={{fontFamily, fontSize, fontWeight}}>{validationMessage}</div>
      )}
    </div>
  );
}
 
export default CustomInput;